export default __webpack_public_path__ + "static/media/MorrisonsVid_01.7a1f45c6.mp4";